import ServiceBase from "base/baseService"
import MunicipioService from "business/cadastro/pessoa/municipio/municipioService"

export default class ListaMunicipioService extends ServiceBase {

    title = "Lista de município"
    pluralTitle = "Lista de municípios"
    url = '/cadastro/fiscal/listamunicipio'
    frontUrl = '/cadastro/fiscal/listamunicipio'
    frontUrlList = '/cadastro/fiscal/listamunicipiolist'
    primaryKey = 'codigo_limu'
    ignoredsSchemaConvertions = ['cod_tilim_limu', 'usu_atua_limu']

    prepareToFront(data = {}) {

        data.descricao_limu = data?.descricao_limu || ''

        data.lista_municipio_item = (data?.lista_municipio_item || []).map(item => {
            const municipio = item?.municipio
            const formattedMunicipio = municipio
                ? this.formatMunicipioOption(
                    municipio.codigo_muni,
                    municipio.descricao_muni,
                    municipio?.uf?.sigla_uf
                )
                : this.formatMunicipioOption(item?.cod_muni_muli, item?.descricao_muni, item?.sigla_uf)

            return {
                action: 'none',
                ...item,
                municipio: formattedMunicipio
            }
        })

        return data
    }

    prepareToSave({ data }) {

        const listaMunicipioItem = (data.lista_municipio_item || []).map(item => {
            const formatted = { ...item }
            formatted.cod_muni_muli = item?.municipio?.codigo_muni || item?.cod_muni_muli || null
            delete formatted.municipio
            return formatted
        })

        data.lista_municipio_item = listaMunicipioItem
        delete data.municipio_busca

        return data
    }

    getNewListaMunicipioItem(data = {}) {
        return {
            action: 'ins',
            cod_muni_muli: null,
            municipio: null,
            ...data
        }
    }

    formatMunicipioOption = (codigo_muni, descricao_muni, sigla_uf) => {
        if (!codigo_muni) return null

        const descricao = sigla_uf ? `${descricao_muni} - ${sigla_uf}` : descricao_muni
        return { codigo_muni, descricao_munuf: descricao }
    }

    async filterMunicipio({ municipio, uf, codigoIbge }) {
        const municipioService = new MunicipioService()
        return municipioService.list(`?page=1&perPage=7&filtertype=combo&descricao_muni=${municipio || ''}&descricao_uf=${uf || ''}&codigoIbge=${codigoIbge || ''}`)
    }

}
